import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from "@angular/core"; import { Location } from "@angular/common";

import { catchError, map, Observable, of } from 'rxjs';

import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { ReponseBase } from './reponse-base';
import { Emplacement } from '../entites/emplacement';
import { Fournisseur } from '../entites/fournisseur';
import { EntreeHistoriqueAchat } from '../entites/entree-historique-achat';
import { PrixFournisseurEntite } from '../entites/prix-fournisseur';
import { EStatuts } from '../entites/enums/statuts';
import { SommaireAchatEntite } from '../entites/sommaireAchatEntite';
import { EvaluationFournisseur } from '../entites/evaluation-fournisseur';
import { NonConformiteSimpleEntite } from '../entites/non-conformite-simple';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class FournisseurService {

  private baseUrl = environment.apiBaseUrl + 'fournisseur';
  private obtenirListeUrl = environment.apiBaseUrl + 'fournisseur';
  private obtenirListeCtrlUrl = environment.apiBaseUrl + 'fournisseur/ctrl';
  private obtenirDetailUrl = environment.apiBaseUrl + 'fournisseur/';
  private obtenirHistoriqueUrl = environment.apiBaseUrl + 'fournisseur/{id}/historique';
  private obtenirSommaireUrl = environment.apiBaseUrl + 'fournisseur/{id}/sommaire';
  private obtenirListePrixUrl = environment.apiBaseUrl + 'fournisseur/{fournisseurId}/prix/{itemId}';
  private obtenirDernierPrixUrl = environment.apiBaseUrl + 'fournisseur/{fournisseurId}/dernierPrix/{itemId}';
  private obtenirListePrixPourItemUrl = environment.apiBaseUrl + 'fournisseur/prix/{itemId}';
  private obtenirNonConformitesLiesAuFournisseurUrl = environment.apiBaseUrl + 'fournisseur/{id}/nonconformites';
  private creerFournisseurUrl = environment.apiBaseUrl + 'fournisseur';
  private modifierFournisseurUrl = environment.apiBaseUrl + 'fournisseur/modifier';
  private creerPrixFournisseurUrl = environment.apiBaseUrl + 'fournisseur/prix';
  private archiverFournisseurUrl = environment.apiBaseUrl + 'fournisseur/archiver';
  private modifierPrixFournisseurUrl = environment.apiBaseUrl + 'fournisseur/prix/modifier';
  private supprimerPrixFournisseurUrl = environment.apiBaseUrl + 'fournisseur/prix/{id}';

  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(
    private http: HttpClient,
    public router: Router,
    private messageService: MessageService
  ) { }

  public ObtenirFournisseurs(): Promise<ReponseBase<Fournisseur[]>> {
    var p = this.http.get<ReponseBase<Fournisseur[]>>(this.obtenirListeUrl)
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirFournisseursCtrl(): Promise<ReponseBase<Fournisseur[]>> {
    var p = this.http.get<ReponseBase<Fournisseur[]>>(this.obtenirListeCtrlUrl)
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirFournisseur(fournisseurId: number): Promise<ReponseBase<Fournisseur>> {

    var p = this.http.get<ReponseBase<Fournisseur>>(this.obtenirDetailUrl + fournisseurId)
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirHistorique(id: number): Promise<ReponseBase<EntreeHistoriqueAchat[]>> {
    var p = this.http.get<ReponseBase<EntreeHistoriqueAchat[]>>(this.obtenirHistoriqueUrl.replace('{id}', id.toString()))
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirSommaire(id: number): Promise<ReponseBase<SommaireAchatEntite[]>> {
    var p = this.http.get<ReponseBase<SommaireAchatEntite[]>>(this.obtenirSommaireUrl.replace('{id}', id.toString()))
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirAutreFournisseurs(itemId: number): Promise<ReponseBase<Fournisseur[]>> {

    var p = this.http.get<any>('assets/demo/data/autresFournisseurs.json')
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirEvaluationsParFournisseur(id: number): Observable<HttpResponse<EvaluationFournisseur[]>> {
    return this.http.get<EvaluationFournisseur[]>(`${this.baseUrl}/${id}/evaluations`, { observe: 'response' });
  }

  public ObtenirEvaluationFournisseur(id: number, idEvaluation: number): Observable<HttpResponse<EvaluationFournisseur>> {
    return this.http.get<EvaluationFournisseur>(`${this.baseUrl}/${id}/evaluation/${idEvaluation}`, { observe: 'response' });
  }

  public AjouterOuModifierEvaluationFournisseur(id: number, evaluation: EvaluationFournisseur): Observable<HttpResponse<EvaluationFournisseur>> {
    return this.http.post<EvaluationFournisseur>(`${this.baseUrl}/${id}/evaluation`, evaluation, { observe: 'response' });
  }

  public SupprimerEvaluationFournisseur(id: number, idEvaluation: number): Observable<HttpResponse<EvaluationFournisseur>> {
    return this.http.delete<EvaluationFournisseur>(`${this.baseUrl}/${id}/evaluation/${idEvaluation}`, { observe: 'response' });
  }

  public ObtenirListePrix(fournisseurId: number, itemId: number): Promise<ReponseBase<PrixFournisseurEntite[]>> {
    var p = this.http.get<ReponseBase<PrixFournisseurEntite[]>>(this.obtenirListePrixUrl.replace('{fournisseurId}', fournisseurId.toString()).replace('{itemId}', itemId.toString()))
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirDernierPrix(fournisseurId: number, itemId: number): Promise<ReponseBase<PrixFournisseurEntite>> {
    var p = this.http.get<ReponseBase<PrixFournisseurEntite>>(this.obtenirDernierPrixUrl.replace('{fournisseurId}', fournisseurId.toString()).replace('{itemId}', itemId.toString()))
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }


  public ObtenirListePrixPourItem(itemId: number): Promise<ReponseBase<PrixFournisseurEntite[]>> {
    var p = this.http.get<ReponseBase<PrixFournisseurEntite[]>>(this.obtenirListePrixPourItemUrl.replace('{itemId}', itemId.toString()))
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirListePrixActifsPourItem(itemId: number, date: Date): Promise<ReponseBase<PrixFournisseurEntite[]>> {
    var p = this.http.get<ReponseBase<PrixFournisseurEntite[]>>(this.obtenirListePrixPourItemUrl.replace('{itemId}', itemId.toString()) + `?dateEffective=${date.toISOString()}`)
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirNonConformitesLiesAuFournisseur(id: number): Observable<NonConformiteSimpleEntite[]> {
    return this.http.get<NonConformiteSimpleEntite[]>(this.obtenirNonConformitesLiesAuFournisseurUrl.replace('{id}', id.toString()), { observe: 'response' })
    .pipe(
      map(response => response.body),
      catchError(error => {
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la récupération des non-conformités liées au fournisseur' });
        return of([]);
      })
    );
  }

  public CreerFournisseur(fournisseur: Fournisseur): Promise<ReponseBase<Fournisseur>> {
    var p = this.http.post<ReponseBase<Fournisseur>>(this.creerFournisseurUrl, JSON.stringify(fournisseur), this.httpOptions)
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ModifierFournisseur(fournisseur: Fournisseur): Promise<ReponseBase<Fournisseur>> {
    var p = this.http.post<ReponseBase<Fournisseur>>(this.modifierFournisseurUrl, JSON.stringify(fournisseur), this.httpOptions)
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ArchiverFournisseur(fournisseur: Fournisseur): Promise<ReponseBase<number>> {
    var p = this.http.post<ReponseBase<number>>(this.archiverFournisseurUrl, JSON.stringify(fournisseur), this.httpOptions)
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public CreerPrixFournisseur(prixFournisseur: PrixFournisseurEntite): Promise<ReponseBase<PrixFournisseurEntite>> {
    var p = this.http.post<ReponseBase<PrixFournisseurEntite>>(this.creerPrixFournisseurUrl, JSON.stringify(prixFournisseur), this.httpOptions)
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ModifierPrixFournisseur(prixFournisseur: PrixFournisseurEntite): Promise<ReponseBase<PrixFournisseurEntite>> {
    var p = this.http.post<ReponseBase<PrixFournisseurEntite>>(this.modifierPrixFournisseurUrl, JSON.stringify(prixFournisseur), this.httpOptions)
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public SupprimerPrixFournisseur(id: number): Promise<ReponseBase<number>> {
    var p = this.http.delete<ReponseBase<number>>(this.supprimerPrixFournisseurUrl.replace('{id}', id.toString()))
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);

      this.log(`${operation} failed: ${error.message}`);

      this.router.navigateByUrl('erreurtechnique');

      return of(result as T);
    };
  }

  getQualityScore(fournisseur: Fournisseur): string {
    if (fournisseur.qualiteProduit == null || fournisseur.qualiteService == null || fournisseur.qualitePrix == null || fournisseur.travail == null) {
      return 'secondary';
    }

    const validScores = [];
    if (fournisseur.qualiteProduit !== 0) validScores.push(fournisseur.qualiteProduit - 1);
    if (fournisseur.qualiteService !== 0) validScores.push(fournisseur.qualiteService - 1);
    if (fournisseur.qualitePrix !== 0) validScores.push(fournisseur.qualitePrix - 1);
    if (fournisseur.travail !== 0) validScores.push(fournisseur.travail - 1);
    const totalScore = validScores.length > 0 ? validScores.reduce((sum, score) => sum + score, 0) / validScores.length : 0;
    return totalScore >= 2.5 ? 'success' : totalScore >= 2 ? 'info' : totalScore >= 1.5 ? 'warning' : 'danger';
  }

  getQualityScoreLabel(fournisseur: Fournisseur): string {
    if (fournisseur.qualiteProduit == null || fournisseur.qualiteService == null || fournisseur.qualitePrix == null || fournisseur.travail == null) {
      return 'Non évalué';
    }

    const validScores = [];
    if (fournisseur.qualiteProduit !== 0) validScores.push(fournisseur.qualiteProduit - 1);
    if (fournisseur.qualiteService !== 0) validScores.push(fournisseur.qualiteService - 1);
    if (fournisseur.qualitePrix !== 0) validScores.push(fournisseur.qualitePrix - 1);
    if (fournisseur.travail !== 0) validScores.push(fournisseur.travail - 1);
    const totalScore = validScores.length > 0 ? validScores.reduce((sum, score) => sum + score, 0) / validScores.length : 0;
    return totalScore >= 2.5 ? 'Très bon' + ' (' + (totalScore * 100 / 3).toFixed(1) + '%)' :  totalScore >= 2 ? 'Bon' + ' (' + (totalScore * 100 / 3).toFixed(1) + '%)' : totalScore >= 1.5 ? 'Acceptable' + ' (' + (totalScore * 100 / 3).toFixed(1) + '%)' : 'Mauvais' + ' (' + (totalScore * 100 / 3).toFixed(1) + '%)';
  }

  getQualityScorePourcentage(fournisseur: Fournisseur): number {
    if (fournisseur.qualiteProduit == null || fournisseur.qualiteService == null || fournisseur.qualitePrix == null || fournisseur.travail == null) {
      return 100.1;
    }

    const validScores = [];
    if (fournisseur.qualiteProduit !== 0) validScores.push(fournisseur.qualiteProduit - 1);
    if (fournisseur.qualiteService !== 0) validScores.push(fournisseur.qualiteService - 1);
    if (fournisseur.qualitePrix !== 0) validScores.push(fournisseur.qualitePrix - 1);
    if (fournisseur.travail !== 0) validScores.push(fournisseur.travail - 1);
    const totalScore = validScores.length > 0 ? validScores.reduce((sum, score) => sum + score, 0) / validScores.length : 0;
    return parseFloat((totalScore * 100 / 3).toFixed(1));
  }

  private log(message: string) {
    console.log(message);
  }
}
